import React from "react";

import { useImageInputContext } from "../../ImageInputContext";
import Placeholder from "../Placeholder";

/**
 * this component will expand in its complexity with time
 */

export const InlineImageInput = ({}) => {
  
  const {
    isLoading,
    value
  } = useImageInputContext();

  return isLoading ? (
    <Placeholder aspectRatio={"4/1"}/>
  ) : value && value[0]?.publicUrl ? (
    <div>
      <img src={value[0]?.publicUrl} style={{width: '100%', height: 'auto'}}/>
    </div>
  ) : null;
};
